import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { STAR_RATING_EMPTY_STATE } from 'marketplace-ui-reviews/constants/RatingTypes';
import WriteReviewButton from './WriteReviewButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewsListEmptyState({
  isPreview = false,
  onWriteReviewClick,
  unreviewableReason
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.emptyStateHeading"
      })
    }), /*#__PURE__*/_jsx(Rating, {
      type: STAR_RATING_EMPTY_STATE,
      rating: 0,
      labelSize: "large",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.reviewCount",
        options: {
          count: 0
        }
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "800",
      as: "div",
      children: /*#__PURE__*/_jsx(WriteReviewButton, {
        disabled: isPreview,
        onClick: onWriteReviewClick,
        size: "md",
        unreviewableReason: unreviewableReason
      })
    })]
  });
}